export default __webpack_public_path__ + "static/media/bullhorn-white.9bc795f5.png";